import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51096780"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_2 = {
  class: "card shadow-none rounded-0 col-12",
  id: "evidence_list_drawer_header"
}
const _hoisted_3 = { class: "px-5" }
const _hoisted_4 = { class: "badge badge-light fw-bold text-dark fs-8" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-30px me-5 text-primary" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Icon",
    src: "/media/svg/files/pdf.svg"
  })
], -1))
const _hoisted_8 = { class: "flex-grow-1" }
const _hoisted_9 = { class: "text-gray-800 text-hover-primary fw-bolder fs-7" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-bold d-block fs-8" }, "2022/02/02 16:34:34 ", -1))
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "badge badge-light-success fs-8 fw-bolder" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Remove")
], -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "badge badge-light-primary fs-8 fw-bolder" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Add")
], -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-30px me-5 text-primary" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Icon",
    src: "/media/svg/files/pdf.svg"
  })
], -1))
const _hoisted_19 = { class: "flex-grow-1" }
const _hoisted_20 = {
  href: "#",
  class: "text-gray-800 text-hover-primary fw-bolder fs-7"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-bold d-block fs-8" }, "2022/02/02 16:34:34 ", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "badge badge-light-success fs-8 fw-bolder" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Remove")
], -1))
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-30px me-5 text-primary" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Icon",
    src: "/media/svg/files/pdf.svg"
  })
], -1))
const _hoisted_25 = { class: "flex-grow-1" }
const _hoisted_26 = {
  href: "#",
  class: "text-gray-800 text-hover-primary fw-bolder fs-7"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-bold d-block fs-8" }, "2022/02/02 16:34:34 ", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "badge badge-light-primary fs-8 fw-bolder" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Add")
], -1))
const _hoisted_29 = ["onClick"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-30px me-5 text-primary" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Icon",
    src: "/media/svg/files/pdf.svg"
  })
], -1))
const _hoisted_31 = { class: "flex-grow-1" }
const _hoisted_32 = {
  href: "#",
  class: "text-gray-800 text-hover-primary fw-bolder fs-7"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-bold d-block fs-8" }, "2022/02/02 16:34:34 ", -1))
const _hoisted_34 = { key: 0 }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "badge badge-light-success fs-8 fw-bolder" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Remove")
], -1))
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = { key: 1 }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "badge badge-light-primary fs-8 fw-bolder" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Add")
], -1))
const _hoisted_39 = [
  _hoisted_38
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    "model-value": _ctx.drawer,
    direction: "rtl",
    size: "525px",
    "append-to-body": true,
    "before-close": _ctx.handleClose,
    "show-close": false,
    withHeader: false
  }, {
    default: _withCtx(() => [
      (_ctx.showProgress)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_el_progress, {
              percentage: 50,
              indeterminate: true,
              "show-text": false
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_collapse, {
            modelValue: _ctx.activeName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeName) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_collapse_item, {
                name: "2",
                class: "fw-boldest"
              }, {
                title: _withCtx(() => [
                  _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.incoming.reason), 1),
                  _createElementVNode("span", _hoisted_5, " " + _toDisplayString(_ctx.incoming.reason_category) + " Documents", 1)
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.libraryEvidence, (evidence, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "d-flex align-items-center mb-2 bg-hover-light",
                      onClick: ($event: any) => (_ctx.onAddLibrary(evidence))
                    }, [
                      _hoisted_7,
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("span", _hoisted_9, _toDisplayString(evidence.evidence_name), 1),
                        _hoisted_10
                      ]),
                      (_ctx.addedEvidences.includes(evidence.id))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
                        : (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
                    ], 8, _hoisted_6))
                  }), 128))
                ]),
                _: 1
              }),
              _createVNode(_component_el_collapse_item, {
                title: "Custom Documents",
                name: "1"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customEvidence, (evidence, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                      (_ctx.addedEvidences.includes(evidence.id))
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "d-flex align-items-center mb-2 bg-hover-light",
                            onClick: ($event: any) => (_ctx.onAddCustom(evidence))
                          }, [
                            _hoisted_18,
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("a", _hoisted_20, _toDisplayString(evidence.evidence_name), 1),
                              _hoisted_21
                            ]),
                            _hoisted_22
                          ], 8, _hoisted_17))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "d-flex align-items-center mb-2 bg-hover-light",
                            onClick: ($event: any) => (_ctx.onAddCustom(evidence))
                          }, [
                            _hoisted_24,
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("a", _hoisted_26, _toDisplayString(evidence.evidence_name), 1),
                              _hoisted_27
                            ]),
                            _hoisted_28
                          ], 8, _hoisted_23))
                    ], 64))
                  }), 128))
                ]),
                _: 1
              }),
              _createVNode(_component_el_collapse_item, {
                title: "API Documents",
                name: "3"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.apiEvidence, (evidence, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "d-flex align-items-center mb-2 bg-hover-light",
                      onClick: ($event: any) => (_ctx.onAddAPI(evidence))
                    }, [
                      _hoisted_30,
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("a", _hoisted_32, _toDisplayString(evidence.evidence_name), 1),
                        _hoisted_33
                      ]),
                      (_ctx.addedEvidences.includes(evidence.id))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_34, _hoisted_36))
                        : (_openBlock(), _createElementBlock("div", _hoisted_37, _hoisted_39))
                    ], 8, _hoisted_29))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value", "before-close"]))
}